<template>
    <div class="event_title">
        <p>공감되는 메시지에 표시해주세요 (중복가능)</p>
    </div>
    <div class="event_content">
        <p class="content_title">"{{ state.currentOption.title }}"</p>
        <ul class="checkbox_options">
            <li v-for="(option, idx) in state.currentOption.contentList">
                <label :for="`option${idx}`" class="custom_check">
                    <input type="checkbox" :id="`option${idx}`" v-model="state.value" :value="option.idx" />
                    <span></span>
                    <div>
                        <p>
                            {{ option.text }}
                            <span>-{{ option.write }}-</span>
                        </p>
                    </div>
                </label>
            </li>
        </ul>
        <p class="content_comment" v-html="state.currentOption.comment"></p>
        <div class="btns">
            <button id="prev" @click="prev" v-if="props.step > 1">이전</button>
            <button id="next" @click="next">다음</button>
        </div>
    </div>

    <ModalDefault v-if="modal.isShow" :type="modal.type" :title="modal.title" :content="modal.content" @close="modal.isShow = false"></ModalDefault>
</template>

<script lang="ts">
    import { reactive, onMounted, watch, ModalDefault } from "@/BaseComponent";

    interface Option {
        step: number;
        title: string;
        contentList: { idx: number; text: string; write: string }[];
        comment: string;
    }

    export default {
        props: {
            step: Number,
            value: Array<Number>,
        },
        emits: ["next", "prev"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                isStart: false,
                value: [] as number[],
                currentOption: {} as Option,
            });

            const modal = reactive({
                isShow: false,
                type: -1,
                title: "",
                content: "",
            });

            const options = [
                {
                    step: 1,
                    title: "당신의 관심이 변화를 만듭니다.",
                    contentList: [
                        { idx: 0, text: "“외면도, 무관심도, 침묵도 성매매 카르텔입니다.”", write: "토미" },
                        { idx: 1, text: "ANTI 성매매에 끊임없이 관심을 가집시다.", write: "참여" },
                        { idx: 2, text: "성매매는 사회의 병적인 존재다. 이제는 변화해야 한다. 제발... ", write: "해설사" },
                    ],
                    comment: `<span>액션시민은 말합니다!!</span> <span>문제를 외면하지 않는 것,</span><span>그것이 변화의 시작입니다.</span>`,
                },
                {
                    step: 2,
                    title: "‘그들’이 아닌 ‘우리’의 문제입니다.",
                    contentList: [
                        { idx: 0, text: "성매매 문제는 남의 일이 아닙니다. 우리가 반드시 해결해야 하므로 함께 해 주십시오", write: "동행 님" },
                        { idx: 1, text: "'그들'(성매매 여성)만의 문제가 아닌 '우리'(여성 그리고 모두)의 문제입니다.", write: "학생 님" },
                        { idx: 2, text: "성매매는 '불법', 성구매자는 '전과자'입니다.", write: "성호 님" },
                    ],
                    comment: `<span>액션시민은 말합니다!!</span> <span>성매매 문제는 누군가의 몫이 아니라</span> <span>우리 모두의 책임입니다.</span>`,
                },
                {
                    step: 3,
                    title: "존중과 인권을 이야기합니다.",
                    contentList: [
                        { idx: 0, text: "성매매는 인권의 문제! 성매매라고 쓰고 성착취(성폭력)라고 읽는다.", write: "아말 님" },
                        { idx: 1, text: "2차  피해만큼은 하지 마십시오. 당신도 똑같은 가해자입니다.", write: "하루 님" },
                        { idx: 2, text: "성매매 없는 사회, 인간의 존중과 가치를 보여주세요.", write: "봉사왕 님" },
                    ],
                    comment: `<span>액션시민은 말합니다!!!</span> <span>편견보단 이해를,</span> <span>낙인보단 존중이 필요합니다.</span>`,
                },
            ] as Option[];

            onMounted(() => {
                if (props.step) changeOption(props.step);
                if (props.value && props.value.length > 0) state.value = props.value;
            });

            const changeOption = (step: number) => {
                const option = options.find((item) => item.step === step);
                if (option) state.currentOption = option;
            };

            const next = () => {
                if (state.value.length === 0) {
                    modal.isShow = true;
                    modal.title = "알림";
                    modal.content = "메시지를 선택해주세요.";
                } else emit("next", state.value);
            };
            const prev = () => {
                emit("prev", state.value);
            };

            watch(
                () => props.step,
                (step) => {
                    changeOption(step);
                    if (props.value && props.value.lenght > 0) state.value = props.value;
                },
            );

            watch(
                () => props.value,
                (value) => {
                    state.value = value;
                },
                { deep: true },
            );

            return {
                props,
                state,
                modal,
                next,
                prev,
            };
        },
    };
</script>

<style scoped></style>
